import { defineStore } from 'pinia'
import { ClientCredTokenAgent } from 'boot/axios'
import { validateJWTToken } from 'src/utils'
import { usePersistedLocalStore } from 'src/stores/persisted-local'
import { useAuthStore } from 'src/stores/auth'
import { useCommonStore } from 'src/stores/common'
import CookieStorage from 'src/utils/CookieStorage'
import { Cookies } from 'quasar'
import { isSsr } from '../constants'
import { encryptStorage } from 'src/utils/pinia-encryption'

export const usePersistedStore = defineStore('persisted', {
  state: () => ({
    clientCred: null,
    selectedLocation: null,
    selectedFulfillment: null,
    locationOrShippingZip: null,
    // isProceedLocation: false,
    selectedZipCode: null,
    authRedirectUri: null,
    modes: {
      activeMode: 4,
      accessCodeValidated: false,
    },
    eaivPersistedSessionId: null,
    eaivPersistedVerificationSuccess: false,
    showEAIVPage: null,
  }),
  getters: {
    currentLocation: (state) => state.selectedLocation,
    currentLocationId: (state) => state.selectedLocation?.locationId,
    clientAccessToken() {
      return this.clientCred && this.clientCred.access_token
    },
    currentLocationName() {
      return (this.currentLocation && this.currentLocation.name) || ''
    },
    selectedFulfillmentCodeName() {
      return this.selectedFulfillment?.codeName || ''
    },
    apiAccessToken() {
      const authStore = useAuthStore()
      return authStore.isLoggedIn
        ? authStore.accessToken
        : this.clientAccessToken
    },
    activeMode() {
      return this.modes.activeMode
    },
    isBetaAccessCodeValidated() {
      return this.modes.accessCodeValidated
    },
    isOfflineModeActive() {
      return this.modes.activeMode === 1
    },
    isTestModeActive() {
      return this.modes.activeMode === 2
    },
    isBetaModeActive() {
      return this.modes.activeMode === 3
    },
  },
  actions: {
    async getToken() {
      const authStore = useAuthStore()
      const commonStore = useCommonStore()

      if (!authStore.isLoggedIn) {
        let token = this.clientCred && this.clientCred.access_token

        // if token is expired
        if (!validateJWTToken(token)) {
          try {
            let { data } = await ClientCredTokenAgent.getToken()

            // await setAxiosHeaders(data.access_token, data.token_type)
            await this.setClientCred({
              access_token: data.access_token,
              // token_type: data.token_type,
            })
          } catch (error) {
            commonStore.setState({
              key: 'storeConfigurationLoaded',
              value: true,
            })
          }
        }
        // if the token is not expired set old one
        else {
          // await setAxiosHeaders(token)
        }
      }
      // if the user is login
      else {
        this.setClientCred(null)
        // await setAxiosHeaders(rootGetters['auth/accessToken'])
      }
    },
    async setServiceLocation(data = {}) {
      const authStore = useAuthStore()
      const persistedLocalStore = usePersistedLocalStore()
      const { location, fulfillment, selectedZipCode, deliveryAddress } = data

      let fulfillmentId =
        fulfillment?.fulfillmentID ||
        fulfillment?.fulfillmentId ||
        fulfillment?.fulfillmentMethodID ||
        ''

      if (authStore.customerExists && location?.locationId && fulfillmentId) {
        try {
          await this.$axiosInstance.put('/Customer/Location/SetPreferred', {
            locationId: location.locationId,
            fulfillmentMethodId: fulfillmentId,
          })
        } catch (error) {}
      }
      // pending
      this.selectLocationAndFulfillments({
        location,
        fulfillment,
        selectedZipCode,
      })

      deliveryAddress &&
        persistedLocalStore.setField({
          field: 'deliveryAddress',
          value: deliveryAddress,
        })

      return true
    },
    setClientCred(clientCred) {
      this.clientCred = clientCred
    },
    selectLocationAndFulfillments(data = {}) {
      const { location, fulfillment, selectedZipCode } = data

      if (location && fulfillment) {
        // state.selectedLocationId = location.locationId

        // ToDo: To be removed
        this.selectedLocation = {
          locationId: location.locationId,
          name: location.name,
          tokenKey: location.tokenKey,
        }

        // state.fulfillmentId =
        //   fulfillment.fulfillmentID ||
        //   fulfillment.fulfillmentId ||
        //   fulfillment.fulfillmentMethodID

        // ToDo: To be removed
        this.selectedFulfillment = {
          fulfillmentId:
            fulfillment.fulfillmentID ||
            fulfillment.fulfillmentId ||
            fulfillment.fulfillmentMethodID,
          codeName: fulfillment.codeName,
          displayName:
            fulfillment.fulfillmentName || fulfillment.displayName || '',
        }

        if (fulfillment.codeName === 'sd') {
          if (location.customerZip)
            this.locationOrShippingZip = location.customerZip
        } else this.locationOrShippingZip = location.address?.zip
      } else {
        this.selectedLocationId = null
        this.fulfillmentId = null

        this.selectedLocation = null
        this.selectedFulfillment = null
        this.locationOrShippingZip = null
      }

      if (selectedZipCode) this.selectedZipCode = selectedZipCode
    },
    setAuthRedirectUri(uri) {
      this.authRedirectUri = uri
    },
    setActiveMode(activeMode) {
      this.modes.activeMode = activeMode
    },
    validateAccessCode(val) {
      this.modes.accessCodeValidated = val
    },
    setEAIVSessionId(sessionId) {
      this.eaivPersistedSessionId = sessionId
    },
    setEAIVVerificationStatus(val) {
      this.eaivPersistedVerificationSuccess = val
    },
    setShowEAIVPage(showEAIVPag) {
      this.showEAIVPage = showEAIVPag
    },
    setField({ field, value }) {
      this[field] = value
    },
  },
  // persist: true,
  persist: {
    storage: isSsr ? new CookieStorage(Cookies) : encryptStorage,
  },
})
